import { TagPanelWebComponent } from './component/TagPanelWebComponent';
import { WEB_COMPONENT_TAG_PANEL } from '../../webcomponents.constants';

export { TagPanelWebComponent };

window.customElements.define(WEB_COMPONENT_TAG_PANEL, TagPanelWebComponent);
